import { Button, Form, Modal, Result, Spin } from 'antd';

import { Common } from '@app/web-pages';

import { useEditNode, useGetNode } from '../data';
import { NodeFormData, useNodeForm } from '../libs';

export type EditFormProps = {
  onCancel?: () => void;
  id?: number;
};

export const EditForm = (props: EditFormProps) => {
  const { data, isError, isLoading } = useGetNode(Number(props.id), {
    enabled: !!props.id,
    staleTime: Infinity,
  });

  const edit = useEditNode(props.id);
  const { getFormProps, getSuccessResultProps } = useNodeForm(edit, props.onCancel);

  if (isError || !data) {
    return (
      <Modal {...props} footer={null} width={800}>
        <Common.NotFoundPage subTitle="Sorry, this node does not exist or was deleted." />
      </Modal>
    );
  }

  const initialValues: NodeFormData = {
    name: data.name,
    suppliers: data.suppliers,
    approvalFlow: data.approvalSteps.map((approvalStep) => approvalStep.stageId),
  };

  return isError || !data ? (
    <Common.NotFoundPage subTitle="Sorry, this node does not exist or was deleted." />
  ) : isLoading ? (
    <Spin style={{ width: '100%' }} />
  ) : edit.isSuccess ? (
    <Result
      {...getSuccessResultProps()}
      title="Successfully edited a process!"
      extra={[<Button onClick={props.onCancel} children="Ok" type="primary" />]}
    />
  ) : (
    <Form {...getFormProps()} initialValues={initialValues} />
  );
};
